module.exports = __webpack_public_path__ + "img/trinapp-oneworld_properties.59ed12e3.png";